/* ZELENAE — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Divide titulares en palabras para el reveal línea a línea */
  function splitWords(root) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span'); w.className = 'zl-w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    })(root);
  }

  var io;
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.zl-reveal, .zl-reveal-img, .zl-split, .zl-observe');
    if (!els.length) return;
    (scope || document).querySelectorAll('.zl-split:not([data-split])').forEach(function (el) { el.setAttribute('data-split', ''); splitWords(el); });
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('zl-visible'); }); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('zl-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { if (!e.classList.contains('zl-visible')) io.observe(e); });
  }

  /* Parallax suave del hero */
  function initParallax() {
    var items = document.querySelectorAll('[data-zl-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-zl-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (Math.max(Math.min(r.top, 0), -r.height) * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* Inclinación 3D sutil de tarjetas al cursor */
  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-zl-tilt]').forEach(function (card) {
      var max = parseFloat(card.getAttribute('data-zl-tilt')) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * max) + 'deg');
        card.style.setProperty('--rx', (-y * max) + 'deg');
        card.style.setProperty('--ty', '-6px');
      });
      card.addEventListener('mouseleave', function () { ['--rx', '--ry', '--ty'].forEach(function (p) { card.style.removeProperty(p); }); });
    });
  }

  /* Contadores animados */
  function initCounters() {
    var els = document.querySelectorAll('[data-zl-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-zl-count')) || 0;
      var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = pre + Math.round(to).toLocaleString('en-US') + suf; return; }
      var t0 = null, dur = 1800;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4);
        el.textContent = pre + Math.round(to * e).toLocaleString('en-US') + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var o = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { run(x.target); o.unobserve(x.target); } }); }, { threshold: 0.4 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* Barra de progreso de los pasos */
  function initSteps() {
    document.querySelectorAll('.zl-steps').forEach(function (sec) {
      var bars = sec.querySelectorAll('.zl-steps__progress span');
      var steps = sec.querySelectorAll('.zl-step');
      if (!bars.length || !('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) {
            var idx = Array.prototype.indexOf.call(steps, x.target);
            bars.forEach(function (b, i) { b.classList.toggle('on', i <= idx); });
          }
        });
      }, { threshold: 0.6 });
      steps.forEach(function (s) { o.observe(s); });
    });
  }

  /* Antes / después: deslizador, pestañas y barrido automático */
  function initBeforeAfter() {
    document.querySelectorAll('[data-zl-ba]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var tabs = sec.querySelectorAll('[data-zl-ba-tab]');
      var panels = sec.querySelectorAll('[data-zl-ba-panel]');
      var pill = sec.querySelector('.zl-ba__pill');

      function setP(stage, v) { stage.style.setProperty('--p', v + '%'); var r = stage.querySelector('.zl-ba__range'); if (r && document.activeElement !== r) r.value = v; }
      function sweep(stage) {
        if (reduce || sec.getAttribute('data-sweep') !== 'true' || stage.dataset.swept) return;
        stage.dataset.swept = '1';
        var start = parseFloat(stage.querySelector('.zl-ba__range').value) || 50;
        var keys = [start, 18, 82, start], seg = 900, t0 = null;
        function step(t) {
          if (stage.dataset.touched) return;
          if (!t0) t0 = t;
          var el = t - t0, i = Math.min(Math.floor(el / seg), keys.length - 2), p = Math.min((el - i * seg) / seg, 1);
          var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          setP(stage, keys[i] + (keys[i + 1] - keys[i]) * e);
          if (el < seg * (keys.length - 1)) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 500);
      }
      function movePill(btn) {
        if (!pill || !btn) return;
        pill.style.width = btn.offsetWidth + 'px';
        pill.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
      }

      sec.querySelectorAll('.zl-ba__stage').forEach(function (stage) {
        var range = stage.querySelector('.zl-ba__range');
        if (!range) return;
        range.addEventListener('input', function () { stage.dataset.touched = '1'; stage.style.setProperty('--p', range.value + '%'); });
        range.addEventListener('pointerdown', function () { stage.dataset.touched = '1'; stage.classList.add('is-dragging'); });
        window.addEventListener('pointerup', function () { stage.classList.remove('is-dragging'); });
      });

      tabs.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          tabs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
          panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
          movePill(btn);
          var st = panels[i] && panels[i].querySelector('.zl-ba__stage');
          if (st) sweep(st);
        });
      });
      movePill(sec.querySelector('.zl-ba__tab.is-active'));
      window.addEventListener('resize', function () { movePill(sec.querySelector('.zl-ba__tab.is-active')); });

      var first = sec.querySelector('.zl-ba__panel.is-active .zl-ba__stage');
      if (first && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { sweep(first); o.disconnect(); } }, { threshold: 0.55 });
        o.observe(first);
      }
    });
  }

  /* FAQ: solo uno abierto a la vez */
  function initFaq() {
    document.querySelectorAll('[data-zl-faq-single]').forEach(function (wrap) {
      wrap.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) wrap.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* Página de producto: galería, variantes, cantidad, añadir al carrito */
  function initPdp() {
    var root = document.querySelector('[data-zl-pdp]');
    if (!root) return;
    var mains = root.querySelectorAll('.zl-pdp__main img');
    var thumbs = root.querySelectorAll('.zl-pdp__thumb');
    var cur = 0;
    function show(i) {
      if (!mains.length) return;
      cur = (i + mains.length) % mains.length;
      mains.forEach(function (m, k) { m.classList.toggle('is-active', k === cur); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      var t = thumbs[cur]; if (t && t.scrollIntoView) t.parentElement.scrollTo({ left: t.offsetLeft - 20, top: t.offsetTop - 20, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-zl-prev]'), next = root.querySelector('[data-zl-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    var main = root.querySelector('.zl-pdp__main'), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
    }

    var form = root.querySelector('form.zl-pdp__form');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-zl-price]'), compareEl = root.querySelector('[data-zl-compare]');
    var btns = document.querySelectorAll('[data-zl-add]');
    var stickyPrice = document.querySelector('[data-zl-sticky-price]');
    var dataEl = root.querySelector('[data-zl-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    var labelAdd = root.getAttribute('data-label-add'), labelSold = root.getAttribute('data-label-sold');
    function money(c) {
      var a = (c / 100).toFixed(2);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return Math.round(c / 100).toLocaleString('en-US');
        if (k === 'amount_with_comma_separator') return a.replace('.', ',');
        return Number(a).toLocaleString('en-US', { minimumFractionDigits: 2 });
      });
    }
    function setVariant(v) {
      if (!v) { btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = labelSold; }); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      btns.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? labelAdd : labelSold; });
      if (v.featured_media) {
        var idx = Array.prototype.findIndex.call(mains, function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) show(idx);
      }
    }
    root.querySelectorAll('[data-zl-option]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var sel = [];
        root.querySelectorAll('[data-zl-optgroup]').forEach(function (g) { var c = g.querySelector('input:checked'); sel.push(c ? c.value : null); });
        setVariant(variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }));
      });
    });

    var qty = root.querySelector('[data-zl-qty]');
    root.querySelectorAll('[data-zl-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-zl-qty-step'), 10)); });
    });

    var msg = root.querySelector('[data-zl-msg]');
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (drawer && drawer.getSectionsToRender) {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
      }
      btns.forEach(function (b) { b.classList.add('is-loading'); });
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btns.forEach(function (b) { b.classList.remove('is-loading'); });
          if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
          if (msg) msg.textContent = '';
          if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { form.submit(); });
    });

    var sticky = document.querySelector('.zl-sticky-buy');
    var buyArea = root.querySelector('.zl-pdp__buy');
    if (sticky && buyArea && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(buyArea);
      sticky.querySelector('[data-zl-add]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* Dos modos (Wear it / Wrap it) */
  function initWearWrap() {
    document.querySelectorAll('[data-zl-ww]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var btns = sec.querySelectorAll('[data-zl-ww-btn]'), imgs = sec.querySelectorAll('[data-zl-ww-img]'), panels = sec.querySelectorAll('[data-zl-ww-panel]'), badge = sec.querySelector('[data-zl-ww-badge]');
      var state = 0, timer = null, auto = parseInt(sec.getAttribute('data-auto'), 10) || 0;
      function set(i) {
        state = i; sec.setAttribute('data-state', i);
        btns.forEach(function (b, k) { b.classList.toggle('is-active', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        if (badge && btns[i]) badge.textContent = btns[i].textContent;
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { clearInterval(timer); timer = null; set(k); }); });
      if (auto && !reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && timer === null && !sec.dataset.touched) timer = setInterval(function () { set(state ? 0 : 1); }, auto * 1000);
          else if (!en[0].isIntersecting && timer) { clearInterval(timer); timer = null; }
        }, { threshold: 0.4 }).observe(sec);
        btns.forEach(function (b) { b.addEventListener('click', function () { sec.dataset.touched = '1'; }); });
      }
      set(0);
    });
  }

  /* Termostato interactivo */
  function initThermostat() {
    document.querySelectorAll('[data-zl-th]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var stage = sec.querySelector('.zl-th__stage'), btns = sec.querySelectorAll('[data-zl-th-level]');
      var tempEl = sec.querySelector('[data-zl-th-temp]'), nameEl = sec.querySelector('[data-zl-th-name]'), unit = sec.getAttribute('data-unit') || '';
      var shown = parseFloat(btns[0] && btns[0].dataset.temp) || 0, raf = null;
      function count(to) {
        cancelAnimationFrame(raf);
        var from = shown, t0 = null;
        function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / 700, 1); shown = from + (to - from) * (1 - Math.pow(1 - p, 3)); tempEl.textContent = Math.round(shown) + unit; if (p < 1) raf = requestAnimationFrame(step); }
        if (reduce) { shown = to; tempEl.textContent = Math.round(to) + unit; } else raf = requestAnimationFrame(step);
      }
      function set(i) {
        var b = btns[i]; if (!b) return;
        stage.style.setProperty('--lv', i * 5 / Math.max(btns.length - 1, 1));
        btns.forEach(function (x, k) { x.classList.toggle('is-active', k === i); x.classList.toggle('is-on', k <= i); x.setAttribute('aria-checked', k === i ? 'true' : 'false'); });
        nameEl.textContent = b.dataset.name || '';
        count(parseFloat(b.dataset.temp) || 0);
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { sec.dataset.touched = '1'; set(k); }); });
      if (!reduce && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return; o.disconnect();
          var i = 0; var iv = setInterval(function () { if (sec.dataset.touched || i >= btns.length - 1) { clearInterval(iv); return; } set(++i); }, 550);
        }, { threshold: 0.5 });
        o.observe(stage);
      }
    });
  }

  function initAll(scope) { initReveal(scope); initParallax(); initTilt(); initCounters(); initSteps(); initBeforeAfter(); initWearWrap(); initThermostat(); initFaq(); initPdp(); }
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
